<template>
  <div :id="'accessorials-global' + tripNumber" class="card-accessorials">
    <div
      v-for="(accessorial, index) in accessorialsGlobalLTL"
      v-bind:key="accessorial.id"
    >
      <b-form-checkbox
        v-model="selectedAccessorialsGlobalLTL[index]"
        value="accepted"
        unchecked-value="not_accepted"
        size="sm"
        @input="selectAccessorial(accessorial, index)"
        class="checkbox-group__checkbox"
      >
        {{ accessorial.accessorial }}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { removePointerEvents } from "@/mixins/pickupAndDelivery/standardizers";

export default {
  name: "AccessorialsGlobalLTL",
  props: {
    tripNumber: Number
  },
  data() {
    return {
      selectedAccessorialsGlobalLTL: [],
      accessorialsGlobalLTL: null,
      user: null,
      newTab: null,
      allowed: true,
      item: null,
      assignedUser: null,
      disableEmailResponse: true,
      currentDepartment: null,
      selectedMode: null
    };
  },
  watch: {
    newTab() {
      this.setAccessorialsListNewTab();
    },
    selectedAccessorialsGlobalLTL() {
      return this.$emit("input", this.selectedAccessorialsGlobalLTL);
    },
    accessorials() {
      this.setAccessorialsList();
    },
    showSelectedMode(value) {
      this.selectedMode = value;
    }
  },
  computed: {
    ...mapState({
      accessorials: state => state.quotes.accessorials.accessorials
    }),
    ...mapGetters("quotes/quote", ["showSelectedMode"])
  },
  mounted() {
    this.currentDepartment = JSON.parse(
      localStorage.getItem("current-department")
    );
    this.newTab = this.tripNumber;
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    this.handlerAccessorialsGlobal();
    this.setAccessorialsList();
    return this.$emit("input", this.selectedAccessorialsGlobalLTL);
  },
  methods: {
    handlerAccessorialsGlobal() {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (currentDepartment.department_id == 1 &&
          currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (this.allowed) {
        if (
          (currentDepartment.rol_name == "quoter" &&
            this.$route.params.pathName == "queue") ||
          this.disableEmailResponse ||
          this.item.message.validation_alert
        ) {
          removePointerEvents("accessorials-global" + this.tripNumber);
        }
      } else {
        removePointerEvents("accessorials-global" + this.tripNumber);
      }
    },
    setAccessorialsListNewTab() {
      let response = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      if (response && response !== null) {
        this.accessorialsGlobalLTL = response.filter(
          el => el.accessorial_type === "general"
        );
      }
    },
    setAccessorialsList() {
      let response = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      if (response) {
        this.accessorialsGlobalLTL = response.filter(
          el => el.accessorial_type === "general"
        );
      }
      let accessorialsHaul = this.$store.getters["quotes/quote/showQuoteById"]
        .haul[this.tripNumber - 1].accessorial;
      for (let accessorial of accessorialsHaul) {
        for (let i in this.accessorialsGlobalLTL) {
          if (
            accessorial.accessorial.accessorial_type == "general" &&
            accessorial.accessorial.name ==
              this.accessorialsGlobalLTL[i].accessorial
          ) {
            this.selectedAccessorialsGlobalLTL[i] = "accepted";
          }
        }
      }
    },
    selectAccessorial(accessorial, index) {
      let info = {
        body: {},
        params: null
      };
      info.body.haul_ = this.$store.getters["quotes/quote/showQuoteById"].haul[
        this.tripNumber - 1
      ].id;
      info.body.accessorial_ = accessorial.id;
      info.params = this.selectedMode ?? this.showSelectedMode;
      if (this.selectedAccessorialsGlobalLTL[index] == "accepted") {
        this.$store.dispatch("quotes/accessorials/checkAccessorial", info);
      } else if (this.selectedAccessorialsGlobalLTL[index] == "not_accepted") {
        this.$store.dispatch("quotes/accessorials/uncheckAccessorial", info);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-accessorials {
  @include card;
  height: 100%;
  @include flex-wrap(center);
  flex-direction: row;
}

.checkbox-group {
  &__checkbox {
    text-transform: capitalize;
    margin: 2px 10px !important;
    font-size: 13px !important;
  }
}
</style>
